/* SupportView styles - extracted from Attorney.module.css */

.supportViewWrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 40px 20px;
  box-sizing: border-box;
}

.supportViewContainer {
  max-width: 900px;
  margin: 0 auto;
}

/* ============================================
   HEADER
   ============================================ */
.supportHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 32px;
}

.supportHeaderLeft {
  flex: 1;
}

.supportTitle {
	font-family: "Inter", sans-serif;
	font-size: 1.5rem;
	font-weight: 600;
	margin: 0 0 8px 0;
	color: var(--foreground);
}

:global(.dark) .supportTitle {
  color: var(--foreground);
}

.supportSubtitle {
	font-family: "Inter", sans-serif;
	font-size: 0.875rem;
	color: var(--muted-foreground);
	margin: 0;
}

:global(.dark) .supportSubtitle {
  color: var(--muted-foreground);
}


/* ============================================
   SECTIONS
   ============================================ */
.supportSection {
  margin-bottom: 32px;
}

.supportSectionTitle {
	font-family: "Inter", sans-serif;
	font-size: 1.125rem;
	font-weight: 600;
	color: var(--foreground);
	margin: 0 0 8px 0;
}

:global(.dark) .supportSectionTitle {
  color: var(--foreground);
}

.supportSectionDescription {
	font-family: "Inter", sans-serif;
	font-size: 0.875rem;
	color: var(--muted-foreground);
	margin: 0 0 16px 0;
}

:global(.dark) .supportSectionDescription {
  color: var(--muted-foreground);
}

/* ============================================
   TYPE SELECTOR
   ============================================ */
.supportTypeSelector {
  margin-bottom: 24px;
}

.supportLabel {
	font-family: "Inter", sans-serif;
	font-size: 0.875rem;
	font-weight: 500;
	color: var(--foreground);
	margin-bottom: 8px;
	display: block;
}

:global(.dark) .supportLabel {
  color: var(--foreground);
}

.supportRequired {
  color: var(--destructive);
}

.supportTypeCards {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.supportTypeCard {
  flex: 1;
  min-width: 160px;
  padding: 16px;
  border: 2px solid var(--border);
  border-radius: 8px;
  background: var(--background);
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  text-align: left;
}

:global(.dark) .supportTypeCard {
  background: var(--card);
  border-color: var(--border);
}

.supportTypeCard:hover {
  border-color: var(--primary);
  background: color-mix(in oklch, var(--primary) 5%, transparent);
}

:global(.dark) .supportTypeCard:hover {
  border-color: var(--primary);
  background: color-mix(in oklch, var(--primary) 10%, transparent);
}

.supportTypeCardSelected {
  border-color: var(--primary);
  background: color-mix(in oklch, var(--primary) 8%, transparent);
}

:global(.dark) .supportTypeCardSelected {
  border-color: var(--primary);
  background: color-mix(in oklch, var(--primary) 40%, transparent);
}

.supportTypeLabel {
	font-family: "Inter", sans-serif;
	font-size: 0.875rem;
	font-weight: 600;
	color: var(--foreground);
}

:global(.dark) .supportTypeLabel {
  color: var(--foreground);
}

.supportTypeDescription {
	font-family: "Inter", sans-serif;
	font-size: 0.75rem;
	font-weight: 400;
	color: var(--muted-foreground);
	line-height: 1.4;
}

:global(.dark) .supportTypeDescription {
  color: var(--muted-foreground);
}

/* ============================================
   FORM FIELDS
   ============================================ */
.supportFormFields {
  display: flex;
  flex-direction: column;
  gap: 20px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}

.supportFieldGroup {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.supportTextarea {
	min-height: 7.5rem;
	resize: vertical;
	font-family: "Inter", sans-serif;
	font-size: 0.875rem;
	line-height: 1.5;
	white-space: pre-wrap;
	word-wrap: break-word;
}

.supportTextareaMedium {
	min-height: 8.75rem;
	resize: vertical;
	font-family: "Inter", sans-serif;
	font-size: 0.875rem;
	line-height: 1.5;
	white-space: pre-wrap;
	word-wrap: break-word;
}

.supportTextareaLarge {
	min-height: 11.25rem;
	resize: vertical;
	font-family: "Inter", sans-serif;
	font-size: 0.875rem;
	line-height: 1.5;
	white-space: pre-wrap;
	word-wrap: break-word;
}

:global(.dark) .supportTextarea,
:global(.dark) .supportTextareaMedium,
:global(.dark) .supportTextareaLarge {
  background: var(--background);
  border-color: var(--border);
  color: var(--foreground);
}

:global(.dark) .supportTextarea::placeholder,
:global(.dark) .supportTextareaMedium::placeholder,
:global(.dark) .supportTextareaLarge::placeholder {
  color: var(--muted-foreground);
}

/* ============================================
   FILE UPLOAD
   ============================================ */
.supportUploadZone {
  border: 2px dashed var(--border);
  border-radius: 8px;
  padding: 32px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.15s ease;
  background: var(--secondary);
}

:global(.dark) .supportUploadZone {
  border-color: var(--border);
  background: var(--background);
}

.supportUploadZone:hover {
  border-color: var(--primary);
  background: color-mix(in oklch, var(--primary) 3%, transparent);
}

:global(.dark) .supportUploadZone:hover {
  border-color: var(--primary);
  background: color-mix(in oklch, var(--primary) 8%, transparent);
}

.supportUploadZoneDragging {
  border-color: var(--primary);
  background: color-mix(in oklch, var(--primary) 8%, transparent);
}

:global(.dark) .supportUploadZoneDragging {
  border-color: var(--primary);
  background: color-mix(in oklch, var(--primary) 12%, transparent);
}

.supportFileInput {
  display: none;
}

.supportUploadContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.supportUploadText {
	font-family: "Inter", sans-serif;
	font-size: 0.875rem;
	color: var(--muted-foreground);
}

:global(.dark) .supportUploadText {
  color: var(--muted-foreground);
}

/* ============================================
   IMAGE PREVIEW
   ============================================ */
.supportImagePreviewContainer {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.supportImagePreview {
  position: relative;
  width: 120px;
  height: 90px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--border);
}

:global(.dark) .supportImagePreview {
  border-color: var(--border);
}

.supportImagePreview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.supportImageRemove {
	position: absolute;
	top: 4px;
	right: 4px;
	width: 22px;
	height: 22px;
	border-radius: 50%;
	border: none;
	background: color-mix(in oklch, var(--brand-950) 60%, transparent);
	color: var(--sidebar-foreground);
	font-size: 1rem;
	line-height: 1;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: background 0.15s ease;
}

.supportImageRemove:hover {
  background: rgba(0, 0, 0, 0.8);
}

.supportUploadHint {
	font-family: "Inter", sans-serif;
	font-size: 0.75rem;
	color: var(--muted-foreground);
	margin: 4px 0 0 0;
}

:global(.dark) .supportUploadHint {
  color: var(--muted-foreground);
}

/* ============================================
   SUBMIT BUTTON
   ============================================ */
.supportSubmitRow {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}

.supportSubmitButton {
  min-width: 120px;
}
